import { default as NextLink } from "next/link"
import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import styles from "./icon-card.module.css"
import classNames from "classnames"
import { getAnchorAttrsFromLink } from "@/lib/helpers/linkAttrs"

export default function IconCard({ block }) {
  const { link } = block.attrs

  const settings = {
    "core/heading": { width: "bleed" },
    "core/paragraph": { width: "bleed" },
    "theme/link": { variant: "text-w-icon", noLink: true }
  }

  return (
    <Block block={block} noStyling={true} className={classNames(styles.card)}>
      <Link link={link}>
        <Icon icon={block?.attrs?.icon} />
        <Blocks blocks={block.innerBlocks} settings={settings} />
      </Link>
    </Block>
  )
}

const Link = ({ link, children }) => {
  if (!link) {
    return children
  }

  const attrs = getAnchorAttrsFromLink(link)

  return (
    <NextLink href={link?.url} prefetch={false} {...attrs}>
      {children}
    </NextLink>
  )
}

const Icon = ({ icon }) => {
  if (!icon) {
    return null
  }

  return <div className="icon" dangerouslySetInnerHTML={{ __html: icon }} />
}
